// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskTypeEditScreen from "../../../src/screens/task-types/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskTypeEditRouteProps */

/** @typedef {Record<string, never>} TaskTypeEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskTypeEditRouteProps, TaskTypeEditRouteState>}
 */
class TaskTypeEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Task type")}</ScreenTitle>
        <TaskTypeEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskTypeEditRouteProps>} */
const TaskTypeEditRouteComponent = memo(shapeComponent(TaskTypeEditRoute))

export default TaskTypeEditRouteComponent
